
//local path
/*export const BASE_PATH = "/healarcdemo";  // demo base path here
export const API_URL = "http://localhost:8000/api"; // local api*/

 //demo paths
/*export const BASE_PATH = "/healarcdemo";  // demo base path here
 export const API_URL = "https://app.healarc.com/healarcdemo/backend/api"; // live demo api*/

 //live paths
 export const BASE_PATH = "";  // live base path here
 export const API_URL = "https://app.healarc.com/backend/api"; // live api